import Vue from "vue";
import VueRouter from "vue-router";

import Home from "@/views/home/index.vue";
import Dashboard from "@/views/dashboard/index.vue";
import Comment from "../views/common.vue";
import Device from "../views/device/device.vue";
import Distribute from "../views/device/distribute.vue";
import DeviceMember from "../views/device/member.vue";
import Record from "../views/record/record.vue";
import Onsite from "../views/record/onsite.vue";
import Structure from "../views/structure";
import DepartmentManagement from "../views/structure/department.vue";
import Login from "../views/login";
import Updatepass from "../views/account/updatepass.vue";
import Loginmethod from "../views/account/loginmethod.vue";
import Role from "../views/account/role";
import Visitor from "../views/invite/visitor.vue";
import Approve from "../views/invite/approve.vue";
import Group from "../views/attendance/groupManage.vue";
import addgroup from "../views/attendance/addGroup.vue";
import Classes from "../views/attendance/classes/index.vue";
import Chockin from "../views/attendance/record/chockin.vue";
import Personal from "../views/attendance/record/personal.vue";
import HistoryPersonal from "../views/attendance/record/history/personal.vue";
import Personalsummary from "../views/attendance/record/personalsummary.vue";
import HistoryPersonalsummary from "../views/attendance/record/history/personalsummary.vue";
import Department from "../views/attendance/record/department.vue";
import Departmentsummary from "../views/attendance/record/departmentsummary.vue";
import HistoryDepartmentsummary from "../views/attendance/record/history/departmentsummary.vue";
import schedule from "../views/attendance/schedule.vue";
import EventApproval from "../views/approval/event.vue";
import PersionalApproval from "../views/approval/personnel.vue";
import Help from "../views/account/help.vue";
import Aboutus from "../views/account/aboutus.vue";
import Businesstrips from "../views/attendance/register/businesstrips.vue";
import Goout from "../views/attendance/register/goout.vue";
import Leave from "../views/attendance/register/leave.vue";
import Replacement from "../views/attendance/register/replacement.vue";
import Workovertime from "../views/attendance/register/workovertime.vue";
import Bulletin from "../views/bulletin/index.vue";
import Choosecompany from "../views/login/choosecompany.vue";
import Original from "../views/attendance/record/original.vue";
import HistoryOriginal from "../views/attendance/record/history/original.vue";
import HistoryChockin from "../views/attendance/record/history/chockin.vue";
import Wechat from "../views/attendance/wechat/index.vue";
import test from "../views/test.vue"

//门禁管理页面
import Regulation from "@/views/nexus/timeRule/index.vue"
import Holiday from "@/views/nexus/holidayRule/index.vue"
import RemoteOpenDoor from "@/views/nexus/remoteOpenDoor/index.vue"
import OpenDoorHistory from "@/views/nexus/remoteOpenDoor/openDoorHistory.vue"
import PassageRecord from "@/views/nexus/passageRecordLog/index.vue"
import DoorEvent from "@/views/nexus/doorEvent/index.vue"
import DeviceRegulation from "@/views/nexus/deviceRule/index.vue"
import PermissionAllot from "@/views/nexus/permissionAllot/index.vue"
import EmergencyOpenDoor from "@/views/nexus/emergencyOpenDoor/index.vue";
import EmergencyOpenDoorHistory from "@/views/nexus/emergencyOpenDoor/emergencyOpenDoorHistory.vue";
import Setting from "@/views/account/setting.vue";
import VisitorApply from '@/views/visitor/index.vue';
import VisitorOverview from '@/views/visitor/overview.vue';
import VisitorPassageLog from '@/views/visitor/passageLog.vue';
import VisitorSetting from '@/views/visitor/setting.vue';
import Space from '@/views/space/index.vue';

import Share from '@/views/visitor/share/index.vue';

Vue.use(VueRouter);

const routes = [{
		path: "/",
		redirect: "/login",
	},

	{
		path: "/login",
		name: "login",
		component: Login,
		meta: {
			title: "登录",
		},
	},
	{
		path: "/choosecompany",
		name: "Choosecompany",
		component: Choosecompany,
		meta: {
			title: "选择企业",
		},
	},
	{
		path: "/test",
		name: "test",
		component: test,
		meta: {
			title: "选择企业",
		},
	},
    {
        path: "/share/:id",
        name: "Share",
        component: Share,
        meta: {
            title: "访客信息",
        },
    },
	{
		path: "/comment",
		redirect: "/home",
		component: Comment,
		children: [
			{
				path: "/home",
				name: "Home",
				component: Home,
				meta: {
					title: "首页",
				},
			},
			/*{
				path: "/bulletin",
				name: "Bulletin",
				component: Bulletin,
				meta: {
					title: "数据看板",
				},
			},*/
			{
				path: "/dashboard",
				name: "Dashboard",
				component: Dashboard,
				meta: {
					title: "数据看板",
				},
			},
			{
				path: "/structure",
				name: "Structure",
				component: Structure,
				meta: {
					title: "组织架构",
				},
			},
			{
				path: "/DepartmentManagement",
				name: "DepartmentManagement",
				component: DepartmentManagement,
				meta: {
					title: "部门管理",
				},
			},
			{
				path: "/eventApproval",
				name: "eventApproval",
				component: EventApproval,
				meta: {
					title: "事件审批",
				},
			},
			{
				path: "/persionalApproval",
				name: "persionalApproval",
				component: PersionalApproval,
				meta: {
					title: "人员审批",
				},
			},
			{
				path: "/group",
				name: "Group",
				component: Group,
				meta: {
					title: "考勤组管理",
				},
			},
			{
				path: "/addgroup",
				name: "addgroup",
				component: addgroup,
				meta: {
					title: "新建考勤组",
				},
			},
			{
				path: "/schedule",
				name: "schedule",
				component: schedule,
				meta: {
					title: "排班",
				},
			},
			{
				path: "/classes",
				name: "classes",
				component: Classes,
				meta: {
					title: "班次设置",
				},
			},
			{
				path: "/wechat",
				name: "wechat",
				component: Wechat,
				meta: {
					title: "小程序打卡",
				},
			},
			{
				path: "/businesstrips",
				name: "businesstrips",
				component: Businesstrips,
				meta: {
					title: "登记出差",
				},
			},
			{
				path: "/goout",
				name: "goout",
				component: Goout,
				meta: {
					title: "登记外出",
				},
			},
			{
				path: "/leave",
				name: "leave",
				component: Leave,
				meta: {
					title: "登记请假",
				},
			},
			{
				path: "/replacement",
				name: "replacement",
				component: Replacement,
				meta: {
					title: "登记补卡",
				},
			},
			{
				path: "/workovertime",
				name: "workovertime",
				component: Workovertime,
				meta: {
					title: "登记加班",
				},
			},
			{
				path: "/original",
				name: "original",
				component: Original,
				meta: {
					title: "原始记录表",
				},
			},
			{
				path: "/history/original",
				name: "historyOriginal",
				component: HistoryOriginal,
				meta: {
					title: "原始记录表(历史记录)",
				},
			},
			{
				path: "/chockin",
				name: "chockin",
				component: Chockin,
				meta: {
					title: "打卡记录表",
				},
			},
			{
				path: "/history/chockin",
				name: "HistoryChockin",
				component: HistoryChockin,
				meta: {
					title: "打卡记录表(历史记录)",
				},
			},
			{
				path: "/personal",
				name: "personal",
				component: Personal,
				meta: {
					title: "个人考勤明细",
				},
			},
			{
				path: "/history/personal",
				name: "HistoryPersonal",
				component: HistoryPersonal,
				meta: {
					title: "个人考勤明细(历史记录)",
				},
			},
			{
				path: "/personalsummary",
				name: "personalsummary",
				component: Personalsummary,
				meta: {
					title: "个人考勤汇总",
				},
			},
			{
				path: "/history/personalsummary",
				name: "HistoryPersonalsummary",
				component: HistoryPersonalsummary,
				meta: {
					title: "个人考勤汇总(历史记录)",
				},
			},
			{
				path: "/department",
				name: "department",
				component: Department,
				meta: {
					title: "部门考勤明细",
				},
			},
			{
				path: "/departmentsummary",
				name: "departmentsummary",
				component: Departmentsummary,
				meta: {
					title: "部门考勤汇总(历史记录)",
				},
			},
			{
				path: "/history/departmentsummary",
				name: "HistoryDepartmentsummary",
				component: HistoryDepartmentsummary,
				meta: {
					title: "部门考勤汇总",
				},
			},
			{
				path: "/device",
				name: "Device",
				component: Device,
				meta: {
					title: "设备管理",
				},
			},
			{
				path: "/deviceMember",
				name: "DeviceMember",
				component: DeviceMember,
				meta: {
					title: "设备用户管理",
				},
			},
			{
				path: "/distribute",
				name: "Distribute",
				component: Distribute,
				meta: {
					title: "下发任务列表",
				},
			},
			{
				path: "/record",
				name: "Record",
				component: Record,
				meta: {
					title: "通行记录",
				},
			},
			{
				path: "/onsite",
				name: "Onsite",
				component: Onsite,
				meta: {
					title: "在场人员",
				},
			},
			{
				path: "/loginmethod",
				name: "Loginmethod",
				component: Loginmethod,
				meta: {
					title: "登录方式",
					keepAlive: false,
				},
			},
			{
				path: "/updatepass",
				name: "Updatepass",
				component: Updatepass,
				meta: {
					title: "修改密码",
				},
			},
			{
				path: "/setting",
				name: "Setting",
				component: Setting,
				meta: {
					title: "系统配置",
				},
			},
			{
				path: "/role",
				name: "Role",
				component: Role,
				meta: {
					title: "角色权限",
				},
			},
			{
				path: "/help",
				name: "Help",
				component: Help,
				meta: {
					title: "帮助",
				},
			},
			{
				path: "/aboutus",
				name: "Aboutus",
				component: Aboutus,
				meta: {
					title: "关于我们",
				},
			},
			{
				path: "/timeRule",
				name: "timeRule",
				component: Regulation,
				meta: {
					title: "门禁规则",
				},
			},
			{
				path: "/holidayRule",
				name: "holidayRule",
				component: Holiday,
				meta: {
					title: "节假日规则",
				},
			},
			{
				path: "/deviceRule",
				name: "deviceRule",
				component: DeviceRegulation,
				meta: {
					title: "设备门禁规则",
				},
			},
			{
				path: "/permissionAllot",
				name: "permissionAllot",
				component: PermissionAllot,
				meta: {
					title: "权限下发",
				},
			},
			{
				path: "/remoteOpenDoor",
				name: "remoteOpenDoor",
				component: RemoteOpenDoor,
				meta: {
					title: "远程开门",
				},
			},
			{
				path: "/history/openDoorHistory",
				name: "openDoorHistory",
				component: OpenDoorHistory,
				meta: {
					title: "开门记录",
				},
			},
			{
				path: "/passageRecordLog",
				name: "passageRecordLog",
				component: PassageRecord,
				meta: {
					title: "通行记录",
				},
			},
			{
				path: "/doorEvent",
				name: "doorEvent",
				component: DoorEvent,
				meta: {
					title: "门禁事件",
				},
			},
			{
				path: "/emergencyOpenDoor",
				name: "emergencyOpenDoor",
				component: EmergencyOpenDoor,
				meta: {
					title: "紧急开关门",
				},
			},
			{
				path: "/history/emergencyOpenDoorHistory",
				name: "emergencyOpenDoorHistory",
				component: EmergencyOpenDoorHistory,
				meta: {
					title: "开门记录",
				},
			},
            {
                path: "/visitor/overview",
                name: "VisitorOverview",
                component: VisitorOverview,
                meta: {
                    title: "访客概览",
                },
            },
            {
                path: "/visitor/apply",
                name: "visitorApply",
                component: VisitorApply,
                meta: {
                    title: "访客申请",
                },
            },
            {
                path: "/visitor/setting",
                name: "visitorSetting",
                component: VisitorSetting,
                meta: {
                    title: "访客设置",
                },
            },
            {
                path: "/visitor/log",
                name: "visitorPassageLog",
                component: VisitorPassageLog,
                meta: {
                    title: "访客通行记录",
                },
            },
            {
                path: "/space",
                name: "space",
                component: Space,
                meta: {
                    title: "区域管理",
                },
            }
		],
	},

	// h5页面
	{
		path: "/invite",
		name: "invite",
		component: Visitor,
		meta: {
			title: "访客信息",
		},
	},
	{
		path: "/visit",
		name: "visit",
		component: Approve,
		meta: {
			title: "访客信息",
		},
	},
];

const router = new VueRouter({
	mode: "hash",
	base: process.env.BASE_URL,
	routes,
});
// 全局抑制导航重复错误
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => {
        if (err.name !== "NavigationDuplicated") throw err;
    });
};
export default router;